import React, { useState } from "react";
import classes from "./RegisterZipGame.module.css";
import Header from "../../components/Header";
import ZipGameStepper from "../../components/ZipGameStepper";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";

const RegisterZipGame = () => {
  const navigate = useNavigate();
  const [msisdn, setMsisdn] = useState("");

  const handleNext = () => {
    if (!msisdn.trim()) return;

    navigate("/verify-otp/zip-game", {
      state: { msisdn },
    });
  };

  return (
    <>
      <Header />

      <div className={classes.container}>

        <div className={classes.header_section}>
          <div className={classes.back_button} onClick={() => {
            navigate("/");
          }}>
            <FaArrowLeft className={classes.back_icon} />
          </div>
        </div>


        <div className={classes.heroCard}>
          <div className={classes.heroBadge}>ZIP GAME</div>
          <h1 className={classes.heroTitle}>Register & Play for Free</h1>
          <p className={classes.heroText}>
            Enter your number to start your Zip Game registration and get the
            chance to win rewards.
          </p>
        </div>

        <ZipGameStepper currentStep={1} />

        <div className={classes.formCard}>
          <div className={classes.section}>
            <div className={classes.sectionHead}>
              <h2 className={classes.sectionTitle}>Enter Mobile Number</h2>
              <p className={classes.sectionText}>
                Please enter your number to continue.
              </p>
            </div>

            <div className={classes.inputGroup}>
              <label className={classes.label} htmlFor="msisdn">
                Mobile Number
              </label>

              <div className={classes.phoneField}>
                <div className={classes.countryBox}>
                  <img
                    src="/assets/images/papua.png"
                    alt="flag"
                    className={classes.flag}
                  />
                  <span className={classes.code}>+675</span>
                </div>

                <input
                  id="msisdn"
                  type="number"
                  className={classes.input}
                  placeholder="Enter mobile number"
                  value={msisdn}
                  onChange={(e) => setMsisdn(e.target.value)}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>

            <div className={classes.infoBox}>
              <p>
                We will send a one-time password to this number for verification.
              </p>
            </div>

            <button type="button" className={classes.primaryBtn} onClick={handleNext}>
              Send OTP
            </button>

            {/* here it will be the login option */}
            <p className={classes.link_text}>
              Already a User?{" "}<span onClick={() => navigate("/login/zip-game")}>Login Here</span>
            </p>

          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterZipGame;